







































































































import Vue from "vue";
import FormDialog, { iFormDialogOptions } from "@/components/FormDialog.vue";
import TopupPhone from "./TopupPhone.vue";
import FileDownload from "js-file-download";
import { mapActions } from "vuex";

export default Vue.extend({
  name: "topup-group",
  props: ["topics", "selectedTopics"],
  data() {
    return {
      searchDebounce: null,
      search: "",
      selectedCampaign: "",
      selected: [],
      loadDone: false,
      topups: null,
      topupOptions: null,
      page: 1,
      perPage: 10,
      limits: [10, 20, 50, 100, 200, 500, 1000],
      total: 0
    };
  },
  components: {
    FormDialog,
    TopupPhone
  },
  async created() {
    const res = await this.checkShowMenu(this.$route.fullPath);
    if (!res) this.$router.push({ name: "permissionDenied" });
    this.reload();
  },
  methods: {
    ...mapActions({
      checkShowMenu: "menu/checkShowMenu"
    }),
    async reload(local = true) {
      try {
        this.loadDone = false;
        let tasks: any[] = [];
        tasks.push(
          this.$store
            .dispatch("topupGroup/getList", {
              local,
              query: {
                limit: this.perPage,
                filter: this.createFilter(),
                order: { createdAt: -1 },
                page: this.page
              }
            })
            .then(res => {
              this.topups = [...res.map((x, i) => ({ ...x, index: i }))];
            })
        );
        await Promise.all(tasks);

        this.total = this.$store.getters["topupGroup/total"];
      } catch (err) {
        this.$store.dispatch(
          "error/handleError",
          err,
          "Lấy danh sách đọt topup thất bại"
        );
      } finally {
        this.loadDone = true;
      }
    },
    createFilter() {
      let filter = {};
      if (this.search) filter["name"] = { $regex: `${this.search}` };
      if (Object.keys(filter).length) return filter;
      return undefined;
    },
    openTopup(item = null) {
      let text = item ? "Chỉnh sửa đợt topup" : "Thêm đợt topup mới";
      this.topupOptions = {
        title: text,
        confirmText: text,
        confirmFn: async data => {
          if (data) {
            try {
              this.loadDone = false;
              let result = item
                ? await this.$store.dispatch("topupGroup/update", {
                    id: item._id,
                    data
                  })
                : await this.$store.dispatch("topupGroup/add", data);
              this.$buefy.toast.open({
                message: "Thêm topup thành công",
                type: "is-success"
              });
              await this.reload(false);
            } catch (err) {
              this.$store.dispatch(
                "error/handleError",
                err,
                "Thêm bài viết thất bại"
              );
            }
          }
        },
        fields: [
          {
            label: "Tên đợt topup",
            property: "name",
            col: "is-8",
            type: "text",
            required: true,
            current: item ? item.name : ""
          },
          {
            label: "Mệnh giá",
            property: "value",
            col: "is-4",
            type: "select",
            options: [
              { code: 10000, display: "10.000" },
              { code: 20000, display: "20.000" },
              { code: 50000, display: "50.000" }
            ],
            required: true,
            current: item ? item.value : 10000
          }
        ]
      };
    },
    async removeSelected() {
      if (!this.selected || !this.selected.length) return;
      this.$buefy.dialog.confirm({
        message: "Bạn có chắc chắn muốn xóa không?",
        onConfirm: async () => {
          try {
            this.loadDone = false;
            let tasks: any[] = [];
            for (let select of this.selected) {
              tasks.push(
                await this.$store.dispatch("topupGroup/delete", select._id)
              );
            }
            await Promise.all(tasks);
            this.selected = [];
            this.$buefy.toast.open({
              message: "Xóa thành công",
              type: "is-success"
            });
            await this.reload(false);
          } catch (err) {
            this.$store.dispatch(
              "error/handleError",
              err,
              "Xóa topup thất bại"
            );
          } finally {
            this.loadDone = true;
          }
        }
      });
    },
    searchChanged() {
      if (this.searchDebounce) clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.filterChanged();
      }, 300);
    },
    filterChanged() {
      this.page = 1;
      this.reload();
    },
    onPageChange(page) {
      this.page = page;
      this.reload();
    },
    async exportCSV(item) {
      try {
        let data = await this.$store.dispatch("topupGroup/exportCSV", {
          id: item._id
        });
        FileDownload(
          "\uFEFF" + data,
          `Topup_${item.name}.csv`,
          "data:text/plain;charset=utf-8,"
        );
      } catch (err) {
        this.$store.dispatch("error/handleError", err, "Xuất topup thất bại");
      }
    },
    async onFileChanged(event, item) {
      let files = event.target.files;
      let file = files[0] as File;
      if (file) {
        try {
          await this.$store.dispatch("topupGroup/importCSVPhones", {
            id: item._id,
            file
          });
          await this.reload(false);
          this.$buefy.toast.open({
            message: "Import thành công",
            type: "is-success"
          });
        } catch (err) {
          this.$store.dispatch(
            "error/handleError",
            err,
            "Import số topup thất bại"
          );
        }
      }
      event.target.value = "";
    },
    async topup(item) {
      try {
        let res = await this.$store.dispatch("topupGroup/execute", {
          id: item._id
        });
        this.$buefy.toast.open({
          message: `Bắt đầu thực hiện topup cho ${res.results.object.total} số điện thoại`,
          type: "is-success"
        });
      } catch (err) {
        this.$store.dispatch("error/handleError", err, "Topup thất bại");
      }
    }
  }
});
